// initial state
const state = () => ({
      csrfToken: '',
      token: '',
      refreshToken: '',
      photo: '',
      languageCode: '',
      modules: [],
      modulesNotificationsCount: [],
  })

  // getters
  const getters = {

    getState(state) {
        return state;
    },

    getSelectionCardsState(state) {
        return state.entityServices;
    },

    getLastSearchPlateNumber(state) {
        return state.lastSearchPlateNumber;
    },

    isRegistryCompleted(state){
        return state.isRegistryCompleted;
    },

    isTermsAccepted(state){
        return state.acceptedTerms;
    }

  }

  // actions
  const actions = {

  }

  // mutations
  const mutations = {

      setState(state, payload)
      {
          for (var [key, value] of Object.entries(payload)) {
              state[key] = value;
          }
      },

      setTermsAndConditions(state, payload) {
          state.acceptedTerms = payload;
      },

      setLastSearchPlateNumber(state, payload) {
          state.lastSearchPlateNumber = payload;
      },

      setTokenAndRefreshToken(state, payload) {
          state.token = payload.token;
      },

      setModulesDetails(state, payload) {
          state.modules = payload;
      },

      setLanguageCode(state, payload) {
          state.languageCode = payload;
      },

      setClearAuthStorage(state, payload) {
        state = payload;
      },


  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
